import { C3HardwareItem } from '../models/c3-hardware-item.model';
import { C3VendorHardwareData } from '../models/c3-vendor-hardware-data.model';

export function isC3VendorHardwareDataPurchaseReady(
    vendorHardwareData: C3VendorHardwareData,
): boolean {
    return vendorHardwareData.active !== false
        && !!vendorHardwareData.vendorId?.trim()
        && !!vendorHardwareData.sku?.trim()
        && Number.isFinite(vendorHardwareData.cost)
        && vendorHardwareData.cost > 0
        && Number.isFinite(vendorHardwareData.packageQuantity)
        && vendorHardwareData.packageQuantity > 0;
}

export function getPreferredC3VendorHardwareDataId(
    hardwareItem: C3HardwareItem | null | undefined,
    vendorHardwareData: C3VendorHardwareData[],
): string {
    const validVendorHardwareData = vendorHardwareData.filter(
        isC3VendorHardwareDataPurchaseReady,
    );
    const defaultVendorHardwareDataId = hardwareItem?.defaultVendorHardwareDataId || '';

    if (validVendorHardwareData.some(
        (item) => item.id === defaultVendorHardwareDataId,
    )) {
        return defaultVendorHardwareDataId;
    }

    return validVendorHardwareData.length === 1
        ? validVendorHardwareData[0].id
        : '';
}
